import React, { useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { BaseStore } from 'src/store';
import { useLocale } from 'src/modules/locale';
import { ProductEntity, SliderAssetEntity } from 'src/modules/products';
import { Row, Col, Tabs } from 'antd';
import { GlobalImage, GlobalSpin } from 'src/modules/global';
// import { rowThumbnailProps } from 'src/utils/grid';
import { ProductDetailsZoomSlider } from 'src/modules/products';
import { FormattedMessage, useIntl } from 'react-intl';
// import ReactIntense from 'react-intense';
// import ReactIntense from 'src/modules/global/components/ReactIntense/ReactIntense';
import styles from './ProductsDetailsOverlaySectionColor.module.scss';
import { defaultHorizontalGutter } from 'src/utils/grid';

interface ProductsDetailsOverlaySectionColorProps {
  product: ProductEntity;
}

const extractColorCode = (fullColorName: string): number | null => {
  const spaceIndex = fullColorName.indexOf(' ');
  if (spaceIndex !== -1) {
    const code = parseInt(fullColorName.substring(0, spaceIndex), 10);
    if (code) {
      return code;
    }
  }

  return null;
};

const colorSorter = (aFullColorName: string, bFullColorName: string) => {
  // if both color names begin with a numeric color code
  const colorCode1 = extractColorCode(aFullColorName);
  if (colorCode1) {
    const colorCode2 = extractColorCode(bFullColorName);
    if (colorCode2) {
      return colorCode1 < colorCode2 ? -1 : 1;
    }
  }
  return aFullColorName.localeCompare(bFullColorName);
};

const ProductsDetailsOverlaySectionColor: React.FunctionComponent<ProductsDetailsOverlaySectionColorProps> = (
  props: ProductsDetailsOverlaySectionColorProps
) => {
  const intl = useIntl();
  const { TabPane } = Tabs;
  const { getLocalizedObject } = useLocale();

  const initialState: [string, SliderAssetEntity, SliderAssetEntity[]] = ['', null, []];
  const [
    [activeMaterialNameZoomSlider, activeAssetZoomSlider, allAssetsZoomSlider],
    setActiveZoomSlider,
  ] = useState(['', null, []]);

  const {
    // product: { product_variants },
    isLoadingMaterials,
    isLoadedProductMaterials,
    // errorProductMaterials,
    materialColors,
  } = getLocalizedObject(props);

  if (isLoadingMaterials) {
    return <GlobalSpin />;
  }
  const materials: {
    leather?: Record<string, unknown>;
    fabric?: Record<string, unknown>;
    surface?: Record<string, unknown>;
    others?: Record<string, unknown>;
  } = {};

  const materialsRankings: Record<string, number> = {};

  materialColors.forEach((color) => {
    const { material } = color;
    if (material) {
      const category = material.material_category ? material.material_category?.type : 'surface';
      const { name } = material;
      if (!materials[category]) {
        materials[category] = {};
      }
      if (!materials[category][name]) {
        materials[category][name] = {};
      }
      // if (!materials.surface[name]) {
      //   materials.surface[name] = {};
      // }
      materials[category][name][color.name] = color;

      const ranking = color?.material?.ranking;
      if (ranking) {
        materialsRankings[name] = Number(ranking);
      }
    } else {
      const otherSurfacesCategory = intl.formatMessage({
        id: 'page/products/details/section_colors_surfaces/other_surfaces',
      });
      if (!materials.others) {
        materials.others = { [otherSurfacesCategory]: {} };
      }
      materials.others[otherSurfacesCategory][color.name] = color;
    }
  });

  // materialColors.forEach(materialColor => {
  //   const category = materialColor.material?.material_category;
  //   if(materials)
  // })

  // Group materials by material category (leather, fabric or surface)
  // isLoadedProductMaterials &&
  //   product_variants.forEach((productVariant) => {
  //     productVariant.materials?.forEach((material) => {
  //       // Some materials don't have a category so they will be group temporarely as "Others"
  //       const { material_category, name } = material;
  //       const { type: category } = material_category || {};
  //       let type = materials[category];
  //       if (!type) {
  //         type = materials[category] = {};
  //       }
  //       if (!type[name]) {
  //         type[name] = {};
  //       }
  //       // To avoid duplicates, all material colors are stored in an object whose properties are the color names
  //       material.material_colors.forEach((color) => {
  //         type[name][color.name] = color;
  //       });
  //     });

  //     //Material colors for other surfaces ( frames/configuration dependent)
  //     if (productVariant.material_colors?.length) {
  //       productVariant.material_colors?.forEach((color) => {
  //         const material = color.material;
  //         if (material) {
  //           if (!materials.surface) {
  //             materials.surface = {};
  //           }
  //           const { name } = material;
  //           if (!materials.surface[name]) {
  //             materials.surface[name] = {};
  //           }
  //           materials.surface[name][color.name] = color;
  //         } else {
  //           const otherSurfacesCategory = intl.formatMessage({
  //             id: 'page/products/details/section_colors_surfaces/other_surfaces',
  //           });
  //           if (!materials.others) {
  //             materials.others = { [otherSurfacesCategory]: {} };
  //           }
  //           materials.others[otherSurfacesCategory][color.name] = color;
  //         }
  //       });
  //     }
  //   });

  const tabContent = (materials) => {
    if (!isLoadedProductMaterials) {
      return null;
    }

    const sortedMaterialKeys = _.sortBy(Object.keys(materials), (key) => {
      return _.isNumber(materialsRankings[key]) ? materialsRankings[key] : Infinity;
    });

    // return materials sorted by name
    return sortedMaterialKeys.map((materialName) => {
      const currentMaterial = materials[materialName];

      // generate colors elements for the current material
      const colorsJsx = Object.keys(currentMaterial)
        .sort(colorSorter)
        .map((currentColorKey) => {
          const currentColor = currentMaterial[currentColorKey];

          let { name = '' } = currentColor;
          //Capitalize all words of the color name, either separated by white space or hyphen
          if (name.includes('-')) {
            name = name
              .split('-')
              .map((splitName) => {
                if (splitName.includes(' ')) {
                  return splitName
                    .split(' ')
                    .map((name) => _.capitalize(name))
                    .join(' ');
                }
                return _.capitalize(splitName);
              })
              .join('-');
          } else if (name.includes(' ')) {
            name = name
              .split(' ')
              .map((name) => _.capitalize(name))
              .join(' ');
          }
          return (
            <Col xs={8} sm={8} md={4} lg={4} key={currentColor.name}>
              {!!currentColor.assets.length && (
                <div
                  className={styles.imageContainer}
                  onClick={() => {
                    const assets = _.values(currentMaterial)
                      .sort((a, b) => colorSorter(a.name, b.name))
                      .map((color) => ({
                        ...color.assets[0],
                        name: color.name,
                      }));
                    setActiveZoomSlider([
                      materialName,
                      {
                        ...currentColor.assets[0],
                        name: currentColor.name,
                      },
                      assets,
                    ]);
                  }}>
                  <GlobalImage
                    ratio={4 / 3}
                    alt={currentColor.assets[0].file?.alternativeText}
                    url={currentColor.assets[0].file?.formats.thumbnail.url}
                    className={styles.img}
                  />
                </div>
              )}
              <div className={styles.name}>{name}</div>
            </Col>
          );
        });

      // return the current material container along with its colors
      let displayMaterialName;
      if (materialName.includes('-')) {
        displayMaterialName = materialName.split('-');
        displayMaterialName = displayMaterialName.map((name) => _.capitalize(name)).join('-');
      }
      if (materialName.includes(' ')) {
        displayMaterialName = materialName.split(' ');
        displayMaterialName = displayMaterialName.map((name) => _.capitalize(name)).join(' ');
      }
      return (
        <div key={materialName}>
          <h3>{displayMaterialName || _.capitalize(materialName)}</h3>
          <Row gutter={[defaultHorizontalGutter, 40]}>{colorsJsx}</Row>
        </div>
      );
    });
  };
  const { leather, fabric, ...surfaces } = materials;
  const allSurfaces = _.keys(surfaces).reduce(
    (acc, surface) => ({ ...acc, ...surfaces[surface] }),
    {}
  );
  return (
    <div className={styles.container}>
      <Tabs defaultActiveKey="1">
        {leather && (
          <TabPane
            tab={intl.formatMessage({ id: 'page/products/details/section_colors_leather' })}
            key="1">
            <p className={styles.description}>
              <FormattedMessage id="page/products/details/section_colors_leather_description" />
            </p>
            {tabContent(materials.leather)}
          </TabPane>
        )}
        {fabric && (
          <TabPane
            tab={intl.formatMessage({ id: 'page/products/details/section_colors_fabrics' })}
            key="2">
            <p className={styles.description}>
              <FormattedMessage id="page/products/details/section_colors_fabrics_description" />
            </p>
            {tabContent(materials.fabric)}
          </TabPane>
        )}
        {_.keys(surfaces).length && (
          <TabPane
            tab={intl.formatMessage({ id: 'page/products/details/section_colors_surfaces' })}
            key="3">
            <p className={styles.description}>
              <FormattedMessage id="page/products/details/section_colors_surfaces_description" />
            </p>
            {tabContent(allSurfaces)}
          </TabPane>
        )}
        {/* {materials.others && (
            <TabPane tab="Others" key="4">
              <p className={styles.description}>
                <FormattedMessage id="page/products/details/section_colors_description" />
              </p>
              {tabContent(materials.others)}
            </TabPane>
          )} */}
      </Tabs>
      {!!activeAssetZoomSlider && (
        <ProductDetailsZoomSlider
          activeAsset={activeAssetZoomSlider}
          assets={allAssetsZoomSlider}
          caption={activeMaterialNameZoomSlider}
          onClose={() => setActiveZoomSlider(initialState)}
          fullScreen={false}
          objectFit="cover"
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return { ...state.products.details };
};

export default connect(mapStateToProps)(ProductsDetailsOverlaySectionColor);
